import { Editor, Range, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

import { someNode } from '../../../slatePlugins/common/queries/someNode';
import { EditorType } from '../../Editor/utils';
import { getMatchCondition, NodeFilterOption } from './node-filter';

export const isAtStartOf = (editor: EditorType, format: string) => {
  return (
    isAtStartEdgeOfBlock(editor, { type: format }) ||
    isAtStartEdgeOfBlock(editor, { type: format }, 0)
  );
};

export const getAtStartEdgeOfBlock = (editor: EditorType, format: NodeFilterOption, offset = 1) => {
  const { selection } = editor;
  let element;
  let startPoint;
  if (selection && Range.isCollapsed(selection)) {
    const { anchor } = selection;
    startPoint = anchor;
    if (offset) {
      try {
        startPoint = Editor.after(editor, anchor, { unit: 'offset', distance: offset });
        // eslint-disable-next-line no-empty
      } catch (ex) {}
    }
    const [firstElementEntry] = Editor.nodes(editor, {
      at: startPoint,
      ...getMatchCondition(format),
    });
    element = firstElementEntry;
  }
  return { element, startPoint };
};

export const isAtStartEdgeOfBlock = (editor: EditorType, format: NodeFilterOption, offset = 1) => {
  const { element: firstElementEntry, startPoint } = getAtStartEdgeOfBlock(editor, format, offset);
  if (firstElementEntry && startPoint) {
    return Editor.isStart(editor, startPoint, firstElementEntry[1]);
  }

  return false;
};

export const isAtEndOf = (editor: EditorType, format: string) => {
  return (
    isAtEndEdgeOfBlock(editor, { type: format }) || isAtEndEdgeOfBlock(editor, { type: format }, 0)
  );
};

export const getAtEndEdgeOfBlock = (editor: EditorType, format: NodeFilterOption, offset = 1) => {
  const { selection } = editor;
  let element;
  let endPoint;
  if (selection && Range.isCollapsed(selection)) {
    const { anchor } = selection;
    endPoint = offset
      ? Editor.before(editor, anchor, { unit: 'offset', distance: offset })
      : anchor;
    const [firstElementEntry] = Editor.nodes(editor, {
      at: endPoint,
      ...getMatchCondition(format),
    });
    element = firstElementEntry;
  }
  return { element, endPoint };
};

export const isAtEndEdgeOfBlock = (editor: EditorType, format: NodeFilterOption, offset = 1) => {
  const { element: firstElementEntry, endPoint } = getAtEndEdgeOfBlock(editor, format, offset);
  if (firstElementEntry && endPoint) {
    return Editor.isEnd(editor, endPoint, firstElementEntry[1]);
  }

  return false;
};

export const isInsideOfElement = (editor, type) =>
  someNode(editor, { match: { type } as any, block: true });

export const isAtMiddleOfBlock = (editor, type) =>
  isInsideOfElement(editor, type) && !(isAtStartOf(editor, type) || isAtEndOf(editor, type));

export const reSelectText = async (editor, selectionRange) => {
  if (editor.selection) return;

  // Focus Editor and reselect text
  await ReactEditor.focus(editor);
  await Transforms.select(editor, selectionRange);
};
